import css from "./index.module.css";
import EditIcon from "@mui/icons-material/Edit";
import Input from "../../../../components/Input";
import Button from "../../../../components/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';

import { handleAvatar } from "../../../../utils/avatar";
import { getDataById, updateData, deleteData } from "../../../../utils/fetch";

/**
 * Single listentry for <StudentList />, which renders a studentname, an avatar
 * and the possibility to edit the name.
 * @param {Object} data Studentdata
 * @param {Funtion} setStudents updates the studentlist
 * @param {Number} classId 64 character uuid of given class
 * @param {Boolean} edit Control if the component is in its edit state 
 * @param {Function} setEdit updates the state of edit
 */
const Student = ({ data, setStudents, classId, edit, setEdit }) => {

  /**
   * updates db entry for given studentId
   * @param {Event} Formevent with data "name" 
   */
  const handleUpdateStudent = (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);
    const name = formData.get("name");
    updateData("/api/students", {
      id: data.id,
      name: name,
    }).then(() => {
      getDataById("/api/students/byClass", { classId: classId }).then(
        (students) => {
          setStudents(students);
        }
      );
    });
    setEdit(false);
  };

  /**
   * deletes a given studentid from the db
   */
  const handleDeleteStudent = () => {
    deleteData("/api/students", { id: data.id }).then(() => {
      // Refresh student list after deletion
      getDataById("/api/students/byClass", { classId: classId }).then(
        (students) => {
          setStudents(students);
        }
      );
    });
  };

  const handleRemoveUnwantedNickname = () => {
    updateData("/api/students/nickname", {
      id: data.id,
      nickname: "",
      use_nickname: false
    }).then(() => {
      getDataById("/api/students/byClass", { classId: classId }).then(
        (students) => {
          setStudents(students);
        }
      );
    });
  }

  const handleName = () => {
    if (data.use_nickname) {
      if (data.nickname.length > 15) {
        return data.nickname.substring(0,13) + "..."
      }
      return data.nickname;
    }
    return data.name
  }

  return edit ? (
    <form
      key={data.id}
      className={css.studentCard}
      onSubmit={handleUpdateStudent}
    >
      <div>
        <div className={css.avatar}>
          <DeleteIcon onClick={handleDeleteStudent} />
        </div>
        {edit ? (
          <Input
            type="text"
            id="name"
            name="name"
            defaultValue={data.name}
            simple={true}
            style={css.studentinput}
          />
        ) : (
          <span>{data.name}</span>
        )}
      </div>
      <Button simple={true} type="submit">
        <ArrowForwardIcon className={css.lightStroke}/>
      </Button>
    </form>
  ) : (
    <div key={data.id} className={css.studentCard}>
      <div>
        <div className={css.info}>
          <div className={css.avatar}>
            {handleAvatar(data?.use_avatar, data?.avatar, data?.name)}
          </div>
          {edit ? (
            <Input
              type="text"
              id={data.id}
              name={data.id}
              defaultValue={handleName()}
              simple={true}
              style={css.studentinput}
            />
          ) : (
            <div>
              <span>{handleName()}</span>
              {data.use_nickname && <ManageAccountsIcon onClick={() => handleRemoveUnwantedNickname()}/>}
            </div>
          )}
        </div>
      </div>
      <Button simple={true} onClick={() => setEdit(data.id)}>
        <EditIcon />
      </Button>
    </div>
  );
};

export default Student;
